import { useAuth } from '@features/auth/hooks/useAuth';
import { SiteLayout } from '@features/shared/ui/SiteLayout/SiteLayout';
import { SiteLogoWidget } from '@features/shared/ui/SiteLogo/SiteLogoWidget';

import { AuthRequiredPage } from './AuthRequiredPage';

type Props = {
  back?: string;
};

export function AuthRequiredPageWidget({ back }: Props) {
  const { login } = useAuth();

  return (
    <SiteLayout siteLogo={<SiteLogoWidget />}>
      <AuthRequiredPage onLogin={() => login(back)} />
    </SiteLayout>
  );
}
